<div class="container-1">
    <div class="help-text ml-0">
        После входа будет доступна Палитра компипаста, Сниппеты сохраняемые на сервер, а также Настройки будут сохраняться на сервер.
    </div>
    <form (submit)="act.do(Actions.login, { loginValue, passwordValue })">
        <div class="row noborder">
            <input [(ngModel)]="loginValue" class="inp-1" [placeholder]="text.of('login')" type="text" name="username" #inpLogin>
        </div>
        <div class="row noborder">
            <input [(ngModel)]="passwordValue" class="inp-1" [placeholder]="text.of('password')" type="password" name="password">
        </div>
        <div class="row noborder">
            <button class="btn-1 ml-0" type="submit">{{text.of('login button')}}</button>
        </div>
        <div class="row noborder">
            {{model.loginResultMessage}}
        </div>
    </form>
</div>
